<div style="display:flex; height:100%; width:100%">
  <div style="flex: 1 auto" class="no-header-layout">   
    <section class="main-content" [ngStyle]="themeManager.getUnderlayStyle(true)">
      <router-outlet></router-outlet>
    </section>
  </div>
</div>
